import { Base64, UUID } from '../../types'

export function toBase64(value: string): Base64 {
    return value as Base64;
}

export function toUUID(value: string): UUID {
    return value as UUID;
}